import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'semantic-ui-react'
import { renderInput, IsNotNullOrEmptyOrUndefined } from '../../util';
import { unidadMedida } from '../../catalogos';
import { clearErrors, setError } from '../../actions';
import SearchInventario from '../search/searchInventario';
import { LineaDetalle } from '../../models/lineaDetalle';
import { Impuesto } from '../../models/impuesto';
import { Descuento } from '../../models/descuento';
import InputField from './InputField';
import Impuestos from './impuestos';
import { validateDetalle } from './validateDetalle';
import BasicMessage from '../messages/basicMessage';
import { messageTypeEnum } from '../../enum';
import ReactTooltip from 'react-tooltip';

const Detalle = (props) => {
  const { token, emisorId, isLoginState, agregarDetalle, editarDetalle } = props;
  const [isActiveModalInventario, setIsActiveModalInventario] = useState(false);
  const [addDetalle, setAddDetalle] = useState(LineaDetalle);
  const [addImpuesto, setAddImpuesto] = useState(Impuesto);
  const [addDescuento, setAddDescuento] = useState(Descuento);
  const [isActiveModalImpuesto, setIsActiveModalImpuesto] = useState(false);
  const [isActiveModalError, setIsActiveModalError] = useState(false);
  const [mgType, setMgType] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    props.clearErrors();
  }, []);

  useEffect(() => {
    onChangePrecioUnitario(addDetalle.PrecioUnitario);
  }, [addImpuesto?.Tarifa]);

  useEffect(() => {

    if (IsNotNullOrEmptyOrUndefined(editarDetalle)) {
      setAddDetalle(editarDetalle);

      if (IsNotNullOrEmptyOrUndefined(editarDetalle.Impuestos?.Impuesto[0])) {
        setAddImpuesto(editarDetalle.Impuestos.Impuesto[0]);
      }

    }
  }, [editarDetalle]);

  const onSelectProducto = (producto) => {
    let imp = (parseFloat(producto.PrecioUnitario) * (parseFloat(producto.Impuesto)) / 100);
    imp = isNaN(imp) ? 0 : imp.toFixed(3);


    setAddImpuesto({
      ...addImpuesto,
      Monto: imp
    });


    const Impuestos = {
      Impuesto: [
        { ...addImpuesto, Monto: imp }
      ]
    };
    addDetalle.Impuestos = Impuestos;

    if (addDetalle.Cantidad <= 0 || addDetalle.Cantidad === " ") {
      addDetalle.Cantidad = 1;
    }
    let montoTotal = calcularMontoTotal(addDetalle.Cantidad, producto.PrecioUnitario);
    let subtotal = montoTotal;

    setAddDetalle({
      ...addDetalle,
      ...producto,
      MontoTotalLinea: calcularMontoTotalLinea(subtotal, imp, 0),
      SubTotal: subtotal,
      MontoTotal: montoTotal,
    });

  };


  const enableLoading = (isLoading) => {
    return isLoading ? 'ui active inverted dimmer' : 'ui disabled inverted dimmer';
  };

  const descripcionLabel = () => (
    <>
      <label>Descripción</label>
      <i className="search icon buscar-icon" data-tip="Buscar Productos" onClick={() => setIsActiveModalInventario(true)}></i>< ReactTooltip />
    </>
  );

  const hiddenExoneracion = () => (addDetalle?.Codigo !== "") ? 'calculator icon buscar-icon' : 'column hidden-field';

  const impuestosLabel = () => {
    let display = IsNotNullOrEmptyOrUndefined(addImpuesto?.Tarifa) ? addImpuesto?.Tarifa : '0';
    return (<>
      <label className="label-resaltar">{`Impuestos ${display}%`}</label>
      <i className={`${hiddenExoneracion()}`} data-tip="Seleccionar Impuesto" onClick={() => setIsActiveModalImpuesto(true)}></i>< ReactTooltip />
    </>
    )
  };


  const calcularMontoTotalLinea = (subTotal, montoImpuesto, montoExoneracion) => {
     let total = parseFloat(subTotal) + (parseFloat(montoImpuesto) - parseFloat(montoExoneracion));
    total = isNaN(total) ? 0 : total.toFixed(3);
    return total;
  };

  const calcularMontoTotal = (cantidad, precioUnitario) => {
    let total = (parseFloat(cantidad) * parseFloat(precioUnitario));
    total = isNaN(total) ? 0 : total.toFixed(3);
    return total;
  };
  const calcularPrecioUnitario = (value, tarifa, cantidad) => {
    let total = (parseFloat(value) * 100) / ((parseFloat(tarifa) + 100)) / cantidad;
    total = isNaN(total) ? 0 : total.toFixed(3);

    return total;
  };

  const calcularImpuesto = (subTotal, montoExoneracion) => {
    if (isNaN(montoExoneracion)) {
      montoExoneracion = 0;
    }
    if (addDetalle.Cantidad <= 0 || addDetalle.Cantidad == " ") {
      addDetalle.Cantidad = 1;
    }
    var imp = IsNotNullOrEmptyOrUndefined(addImpuesto) ? parseFloat(subTotal) * (parseFloat(addImpuesto.Tarifa) / 100) : 0;
    imp = isNaN(imp) ? 0 : imp.toFixed(3);

    if (montoExoneracion === 0) {
      setAddImpuesto(
        {
          ...addImpuesto,
          Exoneracion: null
        });
    } else {
      setAddImpuesto(
        {
          ...addImpuesto,
          Monto: imp,
          Exoneracion: {
            ...addImpuesto.Exoneracion,
            MontoExoneracion: montoExoneracion,
          }
        });
    }

    return imp;
  };

  const calcularExoneracion = (subTotal, tarifaExonerada) => {
    return parseFloat(subTotal) * ((tarifaExonerada) / 100);
  };

  const updateDetalle = (field) => {
    setAddDetalle({ ...addDetalle, ...field });
  };

  const onChangeDescuento = (value) => {
    let floatValue = '';
    let montoExoneracion = 0;

    if (!isNaN(parseFloat(value))) {
      floatValue = parseFloat(value);
    }

    let montoTotal = calcularMontoTotal(addDetalle.Cantidad, addDetalle.PrecioUnitario);
    let subtotal = montoTotal;

    if (montoTotal > floatValue) {
      subtotal = montoTotal - floatValue;

    } else {
      floatValue = 0;
    }

    if (addImpuesto?.Exoneracion !== null) {
      montoExoneracion = calcularExoneracion(subtotal, addImpuesto.Exoneracion.TarifaExonerada);
      montoExoneracion = parseFloat(montoExoneracion).toFixed(3);
    }
    if (isNaN(parseFloat(montoExoneracion))) {
      montoExoneracion = parseFloat(0).toFixed(3);
    }
    setAddDescuento({
      ...addDescuento,
      MontoDescuento: floatValue,
      NaturalezaDescuento: "Descuento",
    })

    const imp = calcularImpuesto(subtotal, montoExoneracion);
    const Impuestos = {
      Impuesto: [
        {
          ...addImpuesto,
          Monto: imp,
        }
      ]
    };

    if (montoExoneracion > 0) {
      Impuestos = {
        Impuesto: {
          ...Impuestos?.Impuesto,
          Exoneracion: addImpuesto?.Exoneracion,
          MontoExoneracion: montoExoneracion,
        }
      }
    }

    setAddImpuesto({
      ...addImpuesto,
      Monto: imp,
    });

    const Descuentos = {
      Descuento: [
        {
          ...addDescuento,
          MontoDescuento: floatValue,
          NaturalezaDescuento: "Descuento",
        }
      ]
    };
    setAddDetalle({
      ...addDetalle,
      Descuentos,
      MontoTotalLinea: calcularMontoTotalLinea(subtotal, imp, montoExoneracion),
      Impuestos,
      SubTotal: subtotal.toFixed(3),
      MontoTotal: montoTotal,
    });
  };

  const onChangeCantidad = (value) => {
    let floatValue = '';
    let montoExoneracion = 0;

    if (!isNaN(parseFloat(value))) {
      floatValue = parseFloat(value);
    }

    let montoTotal = calcularMontoTotal(floatValue, addDetalle.PrecioUnitario);
    let subtotal = montoTotal;

    if (IsNotNullOrEmptyOrUndefined(addDescuento?.MontoDescuento)) {
      subtotal = montoTotal - addDescuento.MontoDescuento;
    }

    if (addImpuesto.Exoneracion !== null) {
      montoExoneracion = calcularExoneracion(subtotal, addImpuesto.Exoneracion.TarifaExonerada);
    }

    const imp = calcularImpuesto(subtotal, montoExoneracion);

    const Impuestos = {
      Impuesto: [
        {
          ...addImpuesto,
          Monto: imp,
        }
      ]
    };

    setAddImpuesto({
      ...addImpuesto,
      Monto: imp,
    });


    setAddDetalle({
      ...addDetalle,
      MontoTotalLinea: calcularMontoTotalLinea(subtotal, imp, montoExoneracion),
      Cantidad: floatValue,
      Impuestos,
      SubTotal: subtotal.toFixed(3),
      MontoTotal: montoTotal,
    });
  };

  const onChangeMontoLinea = (value) => {
    let floatValue = '';
    let montoExoneracion = 0;
    let precioUnitario = 0;

    if (!isNaN(parseFloat(value))) {
      floatValue = parseFloat(value).toFixed(3);
    }

    precioUnitario = calcularPrecioUnitario(floatValue, addImpuesto.Tarifa, addDetalle.Cantidad);
    let montoTotal = calcularMontoTotal(addDetalle.Cantidad, precioUnitario);
    let subtotal = montoTotal;

    if (IsNotNullOrEmptyOrUndefined(addImpuesto?.Exoneracion)) {
      montoExoneracion = calcularExoneracion(subtotal, addImpuesto.Exoneracion.TarifaExonerada);
    }

    const imp = calcularImpuesto(subtotal, montoExoneracion);
    const Impuestos = {
      Impuesto: [
        {
          ...addImpuesto,
          Monto: imp,
        }
      ]
    };

    if (montoExoneracion > 0) {
      Impuestos = {
        Impuesto: {
          ...Impuestos?.Impuesto,
          Exoneracion: addImpuesto?.Exoneracion,
          MontoExoneracion: montoExoneracion,
        }
      }
    };

    setAddDescuento({
      ...addDescuento,
      MontoDescuento: 0,
      NaturalezaDescuento: "",
    });


    setAddImpuesto({
      ...addImpuesto,
      Monto: imp,
    });

    setAddDetalle({
      ...addDetalle,
      MontoTotalLinea: floatValue,
      PrecioUnitario: precioUnitario,
      SubTotal: subtotal,
      MontoTotal: montoTotal,
      Impuestos,
      Descuentos: null,
    });
  };

  const onChangePrecioUnitario = (value) => {
    let floatValue = '';
    let montoExoneracion = 0;

    if (!isNaN(parseFloat(value))) {
      floatValue = parseFloat(value).toFixed(3);
    }

    if (addDetalle.Cantidad <= 0 || addDetalle.Cantidad == " " || !IsNotNullOrEmptyOrUndefined(addDetalle.Cantidad)) {
      addDetalle.Cantidad = 1;
    }

    let montoTotal = calcularMontoTotal(addDetalle.Cantidad, floatValue);
    let subtotal = montoTotal;
    if (IsNotNullOrEmptyOrUndefined(addDescuento?.MontoDescuento)) {
      subtotal = montoTotal - addDescuento.MontoDescuento;
    }

    if (IsNotNullOrEmptyOrUndefined(addImpuesto?.Exoneracion)) {
      montoExoneracion = calcularExoneracion(subtotal, addImpuesto.Exoneracion.TarifaExonerada);
      montoExoneracion = parseFloat(montoExoneracion).toFixed(3);
    }

    const imp = calcularImpuesto(subtotal, montoExoneracion);
    const Impuestos = {
      Impuesto: [
        {
          ...addImpuesto,
          Monto: imp,
        }
      ]
    };

    if (montoExoneracion > 0) {
      Impuestos = {
        Impuesto: {
          ...Impuestos?.Impuesto,
          Exoneracion: addImpuesto?.Exoneracion,
          MontoExoneracion: montoExoneracion,
        }
      }
    }

    setAddImpuesto({
      ...addImpuesto,
      Monto: imp,
    });

    setAddDetalle({
      ...addDetalle,
      MontoTotalLinea: calcularMontoTotalLinea(subtotal, imp, montoExoneracion),
      PrecioUnitario: floatValue,
      SubTotal: subtotal.toFixed(3),
      MontoTotal: montoTotal,
      Impuestos,
    });
  }

  const onSelectImpuesto = (impuesto) => {
    let imp = 0;
    let montoExoneracion = 0;
    if (impuesto !== null && impuesto.Exoneracion !== null) {
      if (impuesto.Exoneracion.TarifaExonerada > impuesto.Tarifa) {
        impuesto.Exoneracion.TarifaExonerada = impuesto.Tarifa;
      }

      imp = addDetalle.SubTotal * (impuesto.Tarifa / 100);
      montoExoneracion = calcularExoneracion(addDetalle.SubTotal, impuesto.Exoneracion.TarifaExonerada);
      impuesto.Exoneracion.MontoExoneracion = montoExoneracion;
      /* if (imp >= impuesto.Exoneracion.MontoExoneracion) {
         imp = imp - impuesto.Exoneracion.MontoExoneracion;
       }
       else {
         imp = 0;
       }*/

    } else {
      if (impuesto !== null && impuesto.Codigo !== '00') {
        imp = (addDetalle.SubTotal * (impuesto.Tarifa / 100)).toFixed(3);
      }
    }

    if (impuesto !== null && impuesto.Codigo !== '00') {
      impuesto.Monto = imp;
    }

    const Impuestos = {
      Impuesto: IsNotNullOrEmptyOrUndefined(impuesto) ? [impuesto] : []
    };

    setAddDetalle({
      ...addDetalle,
      Impuestos: Impuestos,
      MontoTotalLinea: calcularMontoTotalLinea(addDetalle.SubTotal, imp, montoExoneracion),
    });

    setAddImpuesto(IsNotNullOrEmptyOrUndefined(impuesto) ? { ...impuesto, Monto: imp } : null);

  };

  const cleanFormDetalle = () => {
    setAddDescuento(Descuento)
    setAddImpuesto(Impuesto);
    setAddDetalle({ ...LineaDetalle, Impuestos: Impuesto, NumeroLinea: 0 });

  };
  const closeMessages = () => {
    setMgType('');
    setMessage('');
  };

  const onclickAgregar = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setMgType('');
    setMessage('');

    const errors = validateDetalle(addDetalle);
    if (Object.entries(errors)?.length === 0) {

      if (!IsNotNullOrEmptyOrUndefined(addDetalle.UnidadMedida)) {
        addDetalle.UnidadMedida = "Unid";
      }

      let montoTotalTemp = parseFloat(addDetalle.MontoTotal);
      let MontoTotalLineaTemp = parseFloat(addDetalle.MontoTotalLinea);
      let subTotalTemp = parseFloat(addDetalle.SubTotal);
      let baseImponibleTemp = parseFloat(addDetalle.MontoTotal);

      addDetalle.MontoTotal = montoTotalTemp;
      addDetalle.MontoTotalLinea = MontoTotalLineaTemp;
      addDetalle.SubTotal = subTotalTemp;
      addDetalle.BaseImponible = baseImponibleTemp;

      addDetalle.Impuestos.Impuesto = [...addDetalle.Impuestos.Impuesto.filter((x) => x.Codigo !== '00')];
      addDetalle.Impuestos.Impuesto.forEach(element => {
        let montoImpuestoTemp = parseFloat(element.Monto).toFixed(3);
        element.Monto = montoImpuestoTemp;
      });

      agregarDetalle(addDetalle);
      cleanFormDetalle();

    } else {
      setMgType(messageTypeEnum.error);
      var s = '';
      if (IsNotNullOrEmptyOrUndefined(errors?.Cantidad)) {
        s += errors?.Cantidad + '  -  ';
      }
      if (IsNotNullOrEmptyOrUndefined(errors?.Codigo)) {
        s += errors?.Codigo + '  -  ';
      }
      if (IsNotNullOrEmptyOrUndefined(errors?.PrecioUnitario)) {
        s += errors?.PrecioUnitario + '  -  ';
      }
      if (IsNotNullOrEmptyOrUndefined(errors?.CodigoComercial?.Codigo)) {
        s += errors?.CodigoComercial.Codigo + '  -  ';
      }
      if (IsNotNullOrEmptyOrUndefined(errors?.Detalle)) {
        s += errors?.Detalle;
      }

      setMessage(s);
      setIsActiveModalError(true);
    }
  };
  return (
    <>

      <div className="doubling four column row  formdetalle-contaner detalle-container">
        <div className="two wide column">

          <InputField
            label='Cantidad'
            value={addDetalle?.Cantidad}
            type="text"
            pattern="^[0-9]+$"
            onChange={(e) => onChangeCantidad(e.target.value)}
          />
        </div>
        <div className="two wide column">
          <InputField
            label="Código"
            value={addDetalle?.CodigoComercial?.Codigo}
            onChange={(e) => updateDetalle({ CodigoComercial: { Codigo: e.target.value, Tipo: '01' } })}
            type="text"
          />
        </div>
        <div className="three wide column">
          <InputField
            label="Código Cabys"
            value={addDetalle?.Codigo}
            onChange={(e) => updateDetalle({ Codigo: e.target.value })}
            type="text"
          />
        </div>
        <div className="nine wide column" style={{ width: "103%" }}>
          <InputField
            label={descripcionLabel()}
            value={addDetalle?.Detalle}
            onChange={(e) => updateDetalle({ Detalle: e.target.value })}
            type="text"
          />
        </div>
      </div>
      <div className="doubling four column row detalle-container">
        <div className="four wide column">
          <InputField
            label="Unidad Medida"
            type="select"
            onChange={(e) => updateDetalle({ UnidadMedida: e.target.value })}
            options={unidadMedida}
            value={addDetalle?.UnidadMedida}
          />
        </div>
        <div className="two wide column">
          <InputField
            label="Precio Unitario"
            value={addDetalle?.PrecioUnitario}
            type="number"
            pattern="^[0-9]+(.[0-9]{0,3})?$"
            onChange={(e) => onChangePrecioUnitario(e.target.value)}
          />
        </div>
        <div className="two wide column">
          <InputField
            label={impuestosLabel()}
            value={addImpuesto?.Monto}
            type="text"
            pattern="^[0-9]+(.[0-9]{0,3})?$"
            disabled
          />
        </div>
        <div className="two wide column">
          <InputField
            label="Exonerado"
            value={IsNotNullOrEmptyOrUndefined(addImpuesto?.Exoneracion) ? addImpuesto.Exoneracion.MontoExoneracion : 0}
            type="text"
            pattern="^[0-9]+(.[0-9]{0,3})?$"
            disabled
          />
        </div>
        <div className="two wide column">
          <InputField
            label="Descuento"
            value={addDescuento?.MontoDescuento}
            component={renderInput}
            type="number"
            pattern="^[0-9]+(.[0-9]{0,3})?$"
            onChange={(e) => onChangeDescuento(e.target.value)}
          />
        </div>
        <div className="two wide column">
          <InputField
            label="Total de Línea"
            type="number"
            value={addDetalle?.MontoTotalLinea}
            onChange={(e) => onChangeMontoLinea(e.target.value)}
            pattern="^[0-9]+(.[0-9]{0,3})?$"
          />
        </div>
        <div className="bottom aligned right aligned two wide column desktop">
          <button
            className="ui positive basic button"
            onClick={(e) => onclickAgregar(e)}
            type="button">Agregar</button>
        </div>
      </div>

      <div className="bottom aligned right aligned sixteen wide column responsive">
        <button
          className="ui positive basic button"
          onClick={(e) => onclickAgregar(e)}
          type="button">Agregar</button>
      </div>

      <Modal
        centered={false}
        size="small"
        open={isActiveModalInventario}
        onClose={() => setIsActiveModalInventario(false)}
      >
        <Modal.Header>Buscar productos</Modal.Header>
        <Modal.Content >

          <div className={enableLoading(isLoginState)}>
            <div className="ui text loader">Espere por favor...</div>
          </div>
          <SearchInventario
            token={token}
            emisorId={emisorId}
            onSelectProducto={(producto) => {
              setIsActiveModalInventario(false);
              onSelectProducto(producto);
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => setIsActiveModalInventario(false)}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>


      {/*Modal Impuesto*/}

      <Modal
        centered={false}
        size="small"
        open={isActiveModalImpuesto}
        onClose={() => setIsActiveModalImpuesto(false)}

      >
        <Modal.Header>Impuestos</Modal.Header>
        <Modal.Content>
          <div className={enableLoading(isLoginState)}>
            <div className="ui text loader">Espere por favor...</div>
          </div>
          <Impuestos
            codigoCabys={addDetalle.Codigo}
            impuesto={addImpuesto}
            onSelectImpuesto={(impuesto) => {
              setIsActiveModalImpuesto(false);
              onSelectImpuesto(impuesto);
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => setIsActiveModalImpuesto(false)}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal
        centered={false}
        size="small"
        open={isActiveModalError}
        onClose={() => setIsActiveModalError(false)}
      >
        <Modal.Header>Error</Modal.Header>
        <Modal.Content>
          <BasicMessage message={message} type={mgType} onClick={() => closeMessages()} />
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => setIsActiveModalError(false)}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoginState: state.isLoginState,
    errorState: state.errorState,
  };
}

export default connect(mapStateToProps,
  {
    clearErrors,
    setError
  }
)(Detalle);